import React from "react";

const toggleIn = (arr, v) => (arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);

export const PolicyAccessFields = ({ value, onChange, options, homes, canManageRoles, compact }) => (
  <div className={`rounded-lg border border-slate-200 ${compact ? "p-3" : "p-4"} space-y-3 bg-slate-50/60`} data-testid="policy-access-fields">
    <div>
      <p className="text-xs font-semibold text-slate-600">Applicable homes <span className="font-normal text-slate-400">(none selected = all homes)</span></p>
      <div className="mt-1.5 flex flex-wrap gap-2">
        {homes.map((h) => (
          <label key={h} className="inline-flex items-center gap-1.5 text-xs bg-white border border-slate-200 rounded-full px-2.5 py-1 cursor-pointer">
            <input type="checkbox" checked={value.home_scope.includes(h)} onChange={() => onChange({ home_scope: toggleIn(value.home_scope, h) })} data-testid={`policy-home-${h}`} />
            {h}
          </label>
        ))}
      </div>
    </div>
    <div>
      <p className="text-xs font-semibold text-slate-600">Who may read this policy</p>
      {!canManageRoles && <p className="text-[12.5px] text-slate-500 mt-1">Defaults to leadership only (CEO, Project Manager, COO, Administration). A policy manager widens access before approval.</p>}
      {canManageRoles && (
        <>
          <label className="mt-1.5 inline-flex items-center gap-2 text-xs font-medium text-slate-800 cursor-pointer">
            <input type="checkbox" checked={!!value.all_roles} onChange={(e) => onChange({ all_roles: e.target.checked })} data-testid="policy-all-roles" />
            All roles — company-wide policy everyone should read
          </label>
          {!value.all_roles && (
            <div className="mt-2 flex flex-wrap gap-2">
              {options.audience_options.map((r) => (
                <label key={r} className="inline-flex items-center gap-1.5 text-xs bg-white border border-slate-200 rounded-full px-2.5 py-1 cursor-pointer">
                  <input type="checkbox" checked={value.permitted_roles.includes(r)} onChange={() => onChange({ permitted_roles: toggleIn(value.permitted_roles, r) })} data-testid={`policy-role-${r.replace(/\s+/g, "-")}`} />
                  {r}
                </label>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  </div>
);
